import {ActionCreatorWithPayload, createAction, createSlice, Draft, PayloadAction} from "@reduxjs/toolkit";
import {Code} from "~/types/accounting-code-type.ts";
import {CommonWorktag} from "~/types/common-worktag-type.ts";
import {LineItemField} from "~/types/code-field-type.ts";

export interface CodeState {
    codes: Code[],
    currentCode: Code,

    meta: {
        fetchingCurrentCode: boolean,
        loadedCurrentCode: boolean,
        fetchingCodes: boolean,
        loadedCodes: boolean,
        currentCodeDirty: boolean
    },
}

export const initialState: CodeState = {
    codes: [],
    currentCode: {
        id: '',
        name: '',
        company: '',
        accountId: '',
        lineItemId: '',
        enabled: true,
        worktags: []
    },

    meta: {
        fetchingCurrentCode: false,
        loadedCurrentCode: false,
        fetchingCodes: false,
        loadedCodes: false,
        currentCodeDirty: false
    },
};

const freshCode = {
    id: '',
    name: '',
    company: '',
    accountId: '',
    lineItemId: '',
    enabled: true,
    worktags: [],
};

const slice = createSlice({
        name: 'codes',
        initialState: initialState,
        reducers: {
            loadCodes: (draft: Draft<CodeState>) => {
                draft.meta.fetchingCodes = true;
                draft.meta.loadedCodes = false;
            },
            receiveCodes: (draft: Draft<CodeState>, {payload}: PayloadAction<Code[]>) => {
                draft.meta.fetchingCodes = false;
                draft.meta.loadedCodes = true;
                draft.codes = payload;
            },
            receiveCodesFailed: (draft: Draft<CodeState>) => {
                draft.meta.fetchingCodes = false;
                draft.meta.loadedCodes = true;
            },
            loadOneCode: (draft: Draft<CodeState>, {payload}: PayloadAction<string>) => {
                draft.meta.fetchingCurrentCode = true;
                draft.meta.loadedCurrentCode = false;
            },
            receiveOneCode: (draft: Draft<CodeState>, {payload}: PayloadAction<Code>) => {
                draft.meta.fetchingCurrentCode = false;
                draft.meta.loadedCurrentCode = true;
                draft.currentCode = payload;
            },
            receiveOneCodeFailed: (draft: Draft<CodeState>) => {
                draft.meta.fetchingCurrentCode = false;
                draft.meta.loadedCurrentCode = true;
            },
            currentCodeReset: (draft: Draft<CodeState>, {payload}: PayloadAction<CommonWorktag[]>) => {
                const worktags: LineItemField[] = [];
                if (Array.isArray(payload)) {
                    payload.forEach((worktag: CommonWorktag) => worktags.push({
                        id: '',
                        name: worktag.code,
                        value: '',
                        required: worktag.required,
                        editable: worktag.editable,
                    }));
                }

                draft.currentCode = {
                    ...freshCode,
                    worktags: worktags
                };
                draft.meta.fetchingCurrentCode = false;
                draft.meta.loadedCurrentCode = true;
            }
        }
    }
);

const updateOneCode: ActionCreatorWithPayload<any> = createAction('codes/updateOneCode');
const deleteOneCode: ActionCreatorWithPayload<string> = createAction('codes/deleteOneCode');

export const actions = {
    ...slice.actions,
    updateOneCode,
    deleteOneCode
};

export default slice.reducer;
